module.exports = __webpack_public_path__ + "static/media/fresh_sp.fd8b5813.jpg";